import EndToEndSection from 'components/Solutions/EndToEndSection';
import React from 'react';
import { IContentWithImage } from 'utils/types';

export interface IEndToEndContainer {
  content: {
    backgroundColor?: string;
    headline: string;
    listOfContentWithImages: IContentWithImage[];
    slug: string;
  };
}

export const EndToEndContainer: React.FC<IEndToEndContainer> = ({
  content,
}) => {
  if (!content) {
    return null;
  }
  const { headline, listOfContentWithImages, backgroundColor, slug } = content;

  const steps = listOfContentWithImages
    .filter((item) => item.image)
    .map((x) => ({ text: x.description?.description || '', image: x.image }));

  const blurbs = listOfContentWithImages
    .filter((item) => !item.image)
    .map((x) => ({
      headline: x.heading || '',
      text: x.description?.description,
    }));

  return (
    <EndToEndSection
      backgroundColor={backgroundColor}
      headline={headline}
      steps={steps}
      blurbs={blurbs}
      slug={slug}
    />
  );
};

export default EndToEndContainer;
